import * as React from 'react';

import { Notification } from 'farmhub-ui-core';
import styled from 'styled-components';

import { useAppDispatch, useAppSelector } from 'app';
import { CollaboratorCreatePageContent } from 'containers/Branding/Collaborator/Collaborator/CreatePage/Content';
import { CollaboratorInChainCreatePageContent } from 'containers/Branding/Collaborator/Collaborator/CreatePage/InChainContent';
import ContentSkeleton from 'containers/Branding/Collaborator/Collaborator/CreatePage/InChainContent/Content/ContentSkeleton';
import { FarmCreatePageContent } from 'containers/Branding/Farm/Farm/CreatePage/Content';
import { FarmInChainCreatePageContent } from 'containers/Branding/Farm/Farm/CreatePage/InChainContent';
import { StoreCreatePageContent } from 'containers/Branding/Store/Store/CreatePage/Content';
import { StoreInChainCreatePageContent } from 'containers/Branding/Store/Store/CreatePage/InChainContent';
import { findWithAuth } from 'slice';

interface CreateAccountProps {
  entityType: string;
  setVisibleModal: (e: boolean) => void;
  setCurrentStep: (e: number) => void;
}

const CreateAccount = ({
  entityType,
  setVisibleModal,
  setCurrentStep,
}: CreateAccountProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = React.useState(false);
  const accountList = useAppSelector(state => state.account.list);
  const reloadAccountsFlag = useAppSelector(state => state.account.reloadFlag);
  const centralEntityID = useAppSelector(
    state => state.account?.item?.centralEntityID
  );

  const isHaveChain = React.useMemo(() => {
    const centralEntities = [...accountList].filter(item => item.isCentral);
    let selectedCentralEntityID = null;
    if (centralEntities.length > 1) {
      if (centralEntityID) {
        const found = centralEntities.find(item => item.id === centralEntityID);
        selectedCentralEntityID = found.id;
      } else {
        const found = centralEntities.find(item => item.role === 'owner');
        selectedCentralEntityID = found?.id;
      }
    } else if (centralEntities.length === 1) {
      if (centralEntities[0].id === centralEntityID) {
        selectedCentralEntityID = centralEntities[0].id;
      }
    }
    return !!selectedCentralEntityID;
  }, [accountList, centralEntityID]);

  React.useEffect(() => {
    const initAccountList = async (): Promise<void> => {
      try {
        setIsLoading(true);
        await dispatch(findWithAuth({ body: {}, query: {} })).unwrap();
      } catch (error: any) {
        Notification('error', 'Tải dữ liệu thất bại', error);
      } finally {
        setIsLoading(false);
      }
    };

    if (accountList.length == 0) {
      initAccountList();
    }
  }, [dispatch, reloadAccountsFlag]);

  return isLoading ? (
    <ContentSkeleton />
  ) : isHaveChain ? (
    <Wrapper>
      {entityType === 'farm' && (
        <FarmInChainCreatePageContent
          setCurrentStep={setCurrentStep}
          setVisibleModal={setVisibleModal}
        />
      )}
      {entityType === 'store' && (
        <StoreInChainCreatePageContent
          setCurrentStep={setCurrentStep}
          setVisibleModal={setVisibleModal}
        />
      )}
      {entityType === 'collaborator' && (
        <CollaboratorInChainCreatePageContent
          setCurrentStep={setCurrentStep}
          setVisibleModal={setVisibleModal}
        />
      )}
    </Wrapper>
  ) : (
    <Wrapper>
      {entityType === 'farm' && (
        <FarmCreatePageContent
          setCurrentStep={setCurrentStep}
          setVisibleModal={setVisibleModal}
        />
      )}
      {entityType === 'store' && (
        <StoreCreatePageContent
          setCurrentStep={setCurrentStep}
          setVisibleModal={setVisibleModal}
        />
      )}
      {entityType === 'collaborator' && (
        <CollaboratorCreatePageContent
          setCurrentStep={setCurrentStep}
          setVisibleModal={setVisibleModal}
        />
      )}
    </Wrapper>
  );
};

export default CreateAccount;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
